export const USER_MANAGEMENT_MODALS = {
  createUser: 'createUser',
  deleteUser: 'deleteUser',
  changePermissionGroup: 'changePermissionGroup',
  transferActiveProjects: 'transferActiveProjects',
  editUserPosition: 'editUserPosition',
  editUser: 'editUser',
};
